import { createUseStyles } from 'react-jss';
import { base } from '../../../css/vars';
import { largeBreak, midBreak } from '../../../css/queries';

export default createUseStyles({
  sidebar: {
    marginBottom: base(2),
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
    ...largeBreak({
      '& > *:not(:last-child)': {
        marginBottom: base(0.5),
      },
      ...midBreak({
        marginBottom: base(),
      }),
    }),
  },
  radio: {
    '&:not(:last-child)': {
      marginBottom: base(0.5),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginRight: base(),
    },
  },
});
